import {Brick, registerBrick, Service} from 'olympe';
import {SUBMIT_PR_SHARED_MEMORY_TOPICS} from '../../../services/service_api/CreateSubmitPRSharedMemory.brick';

/**
 * This brick is responsible for checking if there are PRs being submitted based on a given PR tag and triggering
 * related updates accordingly.
 */
export default class PRsBeingSubmittedHas extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} pRTag
     * @param {function()} forwardEvent
     * @param {function(boolean)} setHas
     */
    update($, [prTag], [forwardEvent, setHas]) {
        Service.get('submitPRSharedMemory', {topic: SUBMIT_PR_SHARED_MEMORY_TOPICS.PRS_BEING_SUBMITTED_HAS, prTag})
            .then((data) => {
                setHas(data.has);
                forwardEvent();
            });
    }
}

registerBrick('0197c5d93fb775811cbf', PRsBeingSubmittedHas);
